import { Vector3 } from 'three';

/**
 * Camera shake from trauma: each hit adds some, it fades on its own, and the shake grows with its square, so small hits
 * barely stir the view and big ones rattle it. Smooth wobbles rather than random jumps, a little different on each axis.
 */
export class Shake {
  private trauma = 0;
  private time = 0;
  private readonly degrees = new Vector3();

  // Small and short: a hit's jitter is over in a blink; the big, readable motion is the head snapping back.
  constructor(private readonly mostDegrees = 3, private readonly fadePerSecond = 4) {}

  /** A hit's worth of trauma, 0..1; it adds up, to at most 1. */
  add(amount: number): void {
    this.trauma = Math.min(1, this.trauma + amount);
  }

  /** The turn of the view this frame, in degrees about x, y and z. */
  update(seconds: number): Vector3 {
    this.time += seconds;
    this.trauma = Math.max(0, this.trauma - this.fadePerSecond * seconds);
    const strength = this.trauma * this.trauma * this.mostDegrees;
    const t = this.time;
    return this.degrees.set(
      strength * wobble(t, 37, 0),
      strength * wobble(t, 29, 1.7),
      strength * 0.6 * wobble(t, 23, 4.1),
    );
  }
}

// Two sines of unrelated frequencies: smooth, never repeating in a way the eye catches, always within -1..1.
function wobble(t: number, frequency: number, phase: number): number {
  return 0.6 * Math.sin(t * frequency + phase) + 0.4 * Math.sin(t * frequency * 1.73 + phase * 2.3);
}
